const aws_techCardDescription: string = `Along with the development, working on Amazon Web Services to achieve the appropriate and best tools.
Deploying the application and connecting the services together. Managing the services according to needs of the projects. With the Cloud Computing on
AWS, giving solutions bestfit for the products and projects.`;

const aws_techTechnologiesAndTools: string[] = [
  'AWS CLI',
  'AWS Amplify',
  'AWS EC2',
  'AWS S3 Bucket',
  'AWS Lambda',
  'AWS SES',
  'AWS ML',
  'AWS SNS',
  'AWS Kinesis',
  'AWS Cognito',
  'AWS Dynamo',
  'AWS Migration Service',
  'AWS Database Migration',
  'AWS Nimble Studio',
]

export { aws_techCardDescription, aws_techTechnologiesAndTools };
